<p class="time">{{ time() | date: 'HH:mm' }}</p>
